<template>
  <div class="number-box">
    <a-input-number
        class="min"
        v-model:value="minValue"
        :disabled="info.status === 'show'"
        :placeholder="info.title + '最小值'"
        :precision="widget.scale"
    />
    <a-input-number
        class="max"
        v-model:value="maxValue"
        :disabled="info.status === 'show'"
        :placeholder="info.title + '最大值'"
        :precision="widget.scale"
    />
  </div>
</template>

<script setup lang="ts">
import {defineProps, ref, watch} from 'vue';
import _ from 'lodash';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {NumberRangeSearch} from "@/components/business/crud/interface/SearchType";

const props = defineProps<{
  propName: string;
  widget: NumberRangeSearch;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const minValue = ref<number>();
const maxValue = ref<number>();

watch(() => data.value[props.propName], () => {
  if (typeof data.value[props.propName]?.$gte === "number") {
    minValue.value = data.value[props.propName]?.$gte;
  } else {
    minValue.value = undefined;
  }
  if (typeof data.value[props.propName]?.$lte === "number") {
    maxValue.value = data.value[props.propName]?.$lte;
  } else {
    maxValue.value = undefined;
  }
})

watch(minValue, () => {
  if (minValue.value !== undefined) {
    _.set(data.value, [props.propName, "$gte"], getValueByType(minValue.value))
  } else if (data.value[props.propName]) {
    _.set(data.value, [props.propName, "$gte"], undefined)
  }
}, {immediate: true, deep: true});

watch(maxValue, () => {
  if (maxValue.value !== undefined) {
    _.set(data.value, [props.propName, "$lte"], getValueByType(maxValue.value))
  } else if (data.value[props.propName]) {
    _.set(data.value, [props.propName, "$lte"], undefined)
  }
}, {immediate: true, deep: true});

function getValueByType(value: string | number) {
  return props.widget.type === "string" ? value.toString() : Number(value);
}
</script>

<style lang="scss" scoped>
.number-box {
  width: 100%;
  display: flex;
  flex-direction: row;

  .min,
  .max {
    flex-grow: 1;
  }

  .min {
    margin-right: $spacing-small;
  }
}
</style>
